import React from "react";
import shape1 from "../../images/shape/heading-shape-1.png";
import shape2 from "../../images/shape/heading-shape-2.png";

import a from "../../images/team/a.webp";
import b from "../../images/team/b.webp";
import c from "../../images/team/c.webp";
import d from "../../images/team/d.webp";
import f from "../../images/team/f.webp";

import ac from "../../images/team/ankit.webp";

let Ankit = () => {
  return (
    <>
      <section className="about-area pb-50">
        <div className="section-header">
          <div className="section-header text-center">
            <img src={ac} className="w100" alt="" />
          </div>
        </div>
        <div className="container">
          <div className="tab-pane mt-50" id="maya">
            <div className="row">
              <div className="col-md-12">
                <div className="profile-details">
                  <h3>Number Cruncher</h3>
                  <hr />
                  <p>
                    Despite being brought up in Mumbai, Ankit has his roots
                    deeply attached to the India’s rural heartlands. He has
                    extensively travelled in rustic parts of India for audit
                    assignments and has firsthand experienced the challenges
                    faced by India’s SME market.
                  </p>
                  <br />
                  <p>
                    His experience of setting up and growing family business in
                    his hometown has helped him to appreciate efforts required
                    by entrepreneurs to build the start-ups. It has also helped
                    him to learn how business problems can be solved by
                    effectively utilizing available resources.
                  </p>
                  <br />
                  <p>
                    With this hunger to make tangible difference and desire to
                    seek newer challenges, Ankit has left corporate life at one
                    of the largest MNCs and joined Radix Capital Advisors to
                    help business and entrepreneurs grow to their full
                    potential.
                  </p>
                  <br />
                  <p>
                    Ankit enjoys playing football in his spare time and has
                    represented his college at university level competition in
                    several tournaments. He is a big foodie who can work all
                    night if given the right snack.
                  </p>
                  <br />
                  <p>
                    Ankit is a qualified Chartered Accountant and has cleared
                    level II of CFA (U.S.A).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-area pt-40 pb-50 animate__animated animate__fadeInUp animate__delay-3s animate__slow	2s">
        <div className="container">
          <div className="section-header mb-100">
            <div className="section-header text-center mb-50">
              <h4 className="section-title mb-25">
                <span>
                  <img src={shape1} className="mr-10" alt="" />
                </span>
                Other Members
                <span>
                  <img src={shape2} className="ml-10" alt="" />
                </span>
              </h4>
            </div>
          </div>

          <div className="d-flex">
            <div className="lineV1"></div>
            <div className="cardTee1">
              <li className="nav-item">
                <a href="/abhishek">
                  <img src={b} alt=" profile " className="img-responsive" />
                  <h6 className="namePosition">
                    Abhishek Taparia <br />
                    <span>
                      <small>(Co-Founder & CEO)</small>
                    </span>
                  </h6>
                </a>
              </li>
            </div>

            <div className="lineV1"></div>
            <div className="cardTee1">
              <li className="nav-item">
                <a href="/maya">
                  <img src={c} alt=" profile " className="img-responsive" />
                  <h6 className="namePosition">
                    Maya Taparia <br />
                    <span>
                      <small>(Co-Founder & COO)</small>
                    </span>
                  </h6>
                </a>
              </li>
            </div>

            <div className="lineV1"></div>
            <div className="cardTee1">
              <li className="nav-item">
                <a href="/mahesh">
                  <img src={a} className="img-responsive" alt="profile" />
                  <h6 className="namePosition">
                    Mahesh T.D. <br />
                    <span>
                      <small>(AVP)</small>
                    </span>
                  </h6>
                </a>
              </li>
            </div>

            <div className="lineV1"></div>
            <div className="cardTee1">
              <li className="nav-item">
                <a href="/jay">
                  <img src={d} alt=" profile " className="img-responsive" />
                  <h6 className="namePosition">
                    Jay Patel <br />{" "}
                    <span>
                      <small>(Senior Associate)</small>
                    </span>
                  </h6>
                </a>
              </li>
            </div>

            <div className="lineV1"></div>
            <div className="cardTee1">
              <li className="nav-item">
                <a href="/ashish">
                  <img src={f} alt=" profile " className="img-responsive" />
                  <h6 className="namePosition">
                    Ashish Chacko <br />{" "}
                    <span>
                      <small>(Analyst)</small>
                    </span>
                  </h6>
                </a>
              </li>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Ankit;
